import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Marquee } from "@/components/Marquee";
import { Creeper } from "@/components/Creeper";
import {
  Hero,
  Gap,
  Approach,
  ImageBand,
  Offerings,
  Outcomes,
  Clients,
  Work,
  About,
  Contact,
  Footer,
} from "@/components/Sections";

const Home = () => {
  useLenis();
  return (
    <div className="paper-noise relative bg-paper">
      {/* Botanical creeper frame around the full page */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[45] hidden md:block">
        <Creeper className="absolute top-0 inset-x-0 w-full h-5" />
        <Creeper className="absolute bottom-0 inset-x-0 w-full h-5" />
        <Creeper vertical className="absolute left-0 inset-y-0 h-full w-5" />
        <Creeper vertical className="absolute right-0 inset-y-0 h-full w-5" />
      </div>
      <Nav />
      <main>
        <Hero />
        <Gap />
        <Approach />
        <ImageBand />
        <Offerings />
        <Marquee />
        <Outcomes />
        <Work />
        <Clients />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" theme="light" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
